import { combineReducers } from 'redux';
import order from '../../../redux/order/order_reducer';
import application from '../../../redux/application/application_reducer';
import user from '../user/user_reducer';
import navigation from '../navigation/navigation_reducer';
import purchaseDetails from '../../../redux/purchase_details/purchase_details_reducer';
import messageToApp from '../../../redux/message_to_app/message_to_app_reducer';
import wizard from '../wizard/wizard_reducer';
import advisorSelection from '../wizard/advisor_selection/advisor_selection_reducer';
import payment from '../wizard/payment/payment_reducer';
import reading from '../reading/reading_reducer';

export default combineReducers({
  order,
  application,
  user,
  navigation,
  purchaseDetails,
  messageToApp,
  wizard,
  advisorSelection,
  payment,
  reading
});
